$(document).ready ->
  CHAPTER_FILE_LIMITS = $('#chapter_file_limits').val() && JSON.parse($('#chapter_file_limits').val())
  fileObject = {}
  croppie_chapter = ''
  tags_restricted_chapter = $('#tags_restricted').val() == 'true'
  prev_language_id = $('#chapter_name_language').val()
  current_language_id = $('#chapter_name_language').val()
  chapter_banners = {}

  $('#chapters').sortable ->
    cursor: "move"

  $('#chapters').on('sortstop', (event, ui) ->
    data = $('.order_chapter_number').serialize()
    $.ajax(
      type: 'POST'
      url: $(this).data('url')
      data: data
    )
  )

  $($('#chapter_name_language').parent()).click (event) ->
    for result in $('#chapter_name_language_chosen .chosen-results').children()
      text = $(result).text()
      key = $('#chapter_name_language').find('option:contains("'+text+'")').val()
      for id in $('input[id^="chapter_name_multi"]')
        if $(id).attr("id") == 'chapter_name_multi[' + key + ']'
          match = $(id).val()
          break
      if match && match.length > 0
        $(result).addClass("language-green")
        $(result).removeClass("language-orange")
      else
        $(result).addClass("language-orange")
        $(result).removeClass("language-green")

  $('#chapter_name_language').change (event) ->
    prev_language_id = current_language_id
    current_language_id = $(event.target).val()
    $('#chapter-name-' + current_language_id).css("display", "block")
    $('#chapter-name-' + prev_language_id).css("display", "none")
    $('#chapter-banner-' + current_language_id).css("display", "block")
    $('#chapter-banner-' + prev_language_id).css("display", "none")

  $('.modal-for-chapter-tags').click (event) ->
    $('.tag-close').css("background", "none")
    $('.tag-label').css("background", "none")
    $($(event.target).attr("data_link")).openModal()

  $(".upload-chapter-banner-file").change (event) ->
    file_preview = $(event.target).parents('.image-container').find(".upload-preview-chapter-banner").find("img")
    $(this).parents('.image-container').find(".edit-banner-modal").css("display", "inline-block")
    $(this).parents('.image-container').find(".edit-alt-text-chapter-image-modal").css("display", "inline-block")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype = file.type;
    fileObject.filename = file.name;
    language = $('#chapter_name_language').val();
    chapter_banners[language] = {name: file.name, type: file.type}

    return if fileSizeNotInLimit(file,event,".new-banner-modal",CHAPTER_FILE_LIMITS["banner"])
    $(this).parents('.image-container').find('.remove-chapter-banner').parent('.cs-trash').css("opacity", 1)
    $(this).parents('.image-container').find('.remove-chapter-banner').parent('.cs-trash').css("pointer-events", "all")

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      return
    reader.readAsDataURL file
    return

  $('.remove-chapter-banner').click (event) ->
    $($(event.target)[0]).parents('.image-container').find('.upload-preview-chapter-banner').find("img").attr("src", null)
    $($(event.target)[0]).parents('.image-container').find(".edit-alt-text-chapter-image-modal").css("display", "none")
    $($(event.target)[0]).parents('.image-container').find(".edit-banner-modal").css("display", "none")
    $(this).parent('.cs-trash').css("opacity", 0.5)
    $(this).parent('.cs-trash').css("pointer-events", "none")
    return

  $(".edit-banner-modal").click (event) ->
    $("#banner_modal").openModal();
    $("#banner_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');

    cropbox = '#chapter_edit_image_cropbox'
    $(cropbox).attr "src", $($(event.target)[0]).siblings("img").attr("src")

    details = $(this).data('file-details') && $(this).data('file-details').split(',')
    if !fileObject.filetype && details && details.length > 1
      fileObject.filetype = details[1].slice(1).toLowerCase()
      fileObject.filename = details[0]
      language = $('#chapter_name_language').val();
      chapter_banners[language] = {name: details[0], type: details[1].slice(1)}

    $(".upload-preview").removeClass "upload-preview"
    $($(event.target)[0]).parent().addClass "upload-preview"
    $('#editCropChapterBannerModal').find(".upload-preview-chapter-banner").addClass "upload-preview"

    croppie_chapter = $('.croppie').croppie({
      viewport: {
        width: 280,
        height: 190
      }
    });
    if $('#editCropChapterBannerModal').find('.croppie-container').length > 1
      $('#editCropChapterBannerModal').find('.croppie-container:last').appendTo('#editCropChapterBannerModal .main-image-container')
      $('#editCropChapterBannerModal').find('.croppie-container:first').remove()
    return

  move_page_listener = () ->
    $('.modal-for-move-page').click (event) ->
      container = $(this).attr('href')
      $(container).html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>')
      $.ajax(
        type: 'GET'
        url: $(this).data('url')
      ).done((data, textStatus, jqXHR) ->
        $(container).html(data)
        $('.modal-close').click (event) ->
          $(this).parents('.move-modal').closeModal()
          return
        return
      )

  delete_page_listener = () ->
    $('.modal-for-delete-page').click (event) ->
      $('#deletemodal').html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>')
      $.ajax(
        type: 'GET'
        url: $(this).data('url')
      ).done((data, textStatus, jqXHR) ->
        $('#deletemodal').html(data)
        return
      )

  move_page_listener()
  delete_page_listener()

  $('.load-chapter-pages').click ->
    $('#tabs-pages').html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>')
    $.ajax(
      type: 'GET'
      url: $(this).data('url')
    ).done((data, textStatus, jqXHR) ->
      $('#tabs-pages').html(data)
      $('.modal-trigger').leanModal()
      $('.dropdown-button-pages').dropdown({hover: false, alignment: 'right'})
      move_page_listener()
      delete_page_listener()
      hover_chapter_pages()
      window.page_order_sortable()
      $('#movepagemodal').html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>')
      $('#bulkmovepagemodal').html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>')
      return
    )

    croppie_chapter = $('.croppie').croppie({
      viewport: {
        width: 280,
        height: 190
      }
    });
    if $('#editCropChapterBannerModal').find('.croppie-container').length > 1
      $('#editCropChapterBannerModal').find('.croppie-container:last').appendTo('#editCropChapterBannerModal .main-image-container')
      $('#editCropChapterBannerModal').find('.croppie-container:first').remove()
    return

  hover_chapter_pages = () ->
    $('.co-page-listitem').mouseenter ->
      $(this).find('.select-page').css('opacity', 1)

    $('.co-page-listitem').mouseleave ->
      if $('.select-page:checked').length == 0
        $(this).find('.select-page').css('opacity', 0)

    $('.select-page').click ->
      if $('.select-page:checked').length == 0
        $('.select-page').css('opacity', 0)
        $('.bulk-update-options').hide()
        $(this).css('opacity', 1)
      else if $('.select-page:checked').length > 0
        $('.select-page').css('opacity', 1)
        $('.bulk-update-options').show()

      id = $(this).val()
      if $(this).is(':checked')
        $('#dropdown'+id).find('#move-link').hide()
        $('#dropdown'+id).find('#delete-link').hide()
      else
        $('#dropdown'+id).find('#move-link').show()
        $('#dropdown'+id).find('#delete-link').show()

  hover_chapter_pages()

  $('.save-cropped-image-btn').click ->
    if croppie_chapter
      src = croppie_chapter.get(0).src
      format = croppie_chapter.get(0).src.split(';')[0].split('/')[1]
      if !format
        format = 'jpeg'
      croppie_chapter.croppie('result',
        type: 'canvas'
        size: 'original'
        format: format
        quality: '0.99'
      ).then (response) ->
        $('.upload-preview img').attr('src', response)

  $('form[id^="edit_chapter_"]').submit (e) ->
    e.preventDefault()
    $('#loading-modal').openModal({dismissible: false})

    index = 0
    $(e.target).children().find(".chapter-banner-uploaded").each ->
      language_id = $($(e.target).children().find(".chapter-banner-uploaded")[index]).data('language-id').toString()
      chapter_banners[language_id] = {} if chapter_banners[language_id] == undefined
      if $($(e.target).children().find(".chapter-banner-uploaded")[index]).find("img").attr('src') != undefined && $($(e.target).children().find(".chapter-banner-uploaded")[index]).find("img").attr('src').indexOf("base64") != -1
        chapter_banners[language_id]['content'] = $($(e.target).children().find(".chapter-banner-uploaded")[index]).find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      else if $($(e.target).children().find(".chapter-banner-uploaded")[index]).find("img").attr('src') == undefined
        chapter_banners[language_id]['content'] = 'null'
      index++

    name_multi = {}
    for name in $('input[id^="chapter_name_multi"]')
      id = $(name).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      val = $(name).val()
      name_multi[key] = val

    alt_text_for_chapter_images = {}
    for alt_text in $('input[id^="chapter_image_alt_text"]')
      id = $(alt_text).attr("id")
      key = id.split("_").pop()
      val = $(alt_text).val()
      alt_text_for_chapter_images[key] = val

    asset_id_for_images = {}
    for asset_id in $('input[id^="asset-id-chapter-banner"]')
      id = $(asset_id).attr("id")
      key = id.split("-").pop()
      val = $(asset_id).val()
      asset_id_for_images[key] = val
      
    chapter_data = {
      'chapter[alt_text_for_chapter_images]': alt_text_for_chapter_images
      'chapter[custom_images]': chapter_banners
      'chapter[asset_id_for_images]': asset_id_for_images
      'chapter[name]': $(e.target).children().find('#chapter_name').val()
      'chapter[name_multi]': name_multi
      'chapter[status]': $(e.target).children().find('#chapter_status').val()
      'chapter[runtime]': $(e.target).children().find('#chapter_runtime').val()
      'authenticity_token': $('input[name=authenticity_token]').val()
      '_method': 'patch'
    }

    if $(e.target).children().find('#chapter_default_timeout_in_seconds').length > 0
      chapter_data['chapter[default_timeout_in_seconds]'] = $(e.target).children().find('#chapter_default_timeout_in_seconds').val()

    if $(e.target).children().find('#chapter_description').length > 0
      chapter_data['chapter[description]'] = $(e.target).children().find('#chapter_description').val()

    runtime = $(e.target).children().find('#chapter_runtime').val()
    min_runtime = parseInt($(e.target).children().find('#chapter_runtime').attr('min'))
    max_runtime = parseInt($(e.target).children().find('#chapter_runtime').attr('max'))

    if !!!runtime || (runtime >= min_runtime && runtime <= max_runtime)
      $.ajax(
        type: 'POST',
        url: "#{$(this).attr('action')}.json"
        enctype: 'multipart/form-data',
        data: chapter_data
      ).done((data, textStatus, jqXHR) ->
        window.location.href = window.location.href.split("chapters")[0] + "chapters"
        return
      ).fail((jqXHR, textStatus, errorThrown) ->
        alert(jqXHR.responseText)
        $("input[type='submit']").val('Update')
        $("input[type='submit']").attr('disabled', false)
        $('#loading-modal').closeModal()
        return
      )
    else
      alert("Can’t set this runtime because it interferes with the Story Unlocking settings")
    true

  $('#new_chapter').submit (e) ->
    e.preventDefault()
    image_path            = ''
    asset_id              = $(e.target).children().find("#asset-id-chapter-banner").val()
    asset_library_allowed = $(e.target).children().find("#asset_library_allowed").val()
    
    if tags_restricted_chapter && !!!$('#tags_country_tags').val() && !!!$('#tags_office_tags').val() && !!!$('#tags_role_tags').val()
      alert "Chapter needs to have at least one of your assigned tags"
      return

    unless $(e.target).find(".chapter-banner-uploaded").find("img").attr('src') == undefined
      if asset_library_allowed == 'false'
        image_path = $(e.target).find(".chapter-banner-uploaded").find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      else
        image_path = ''

    runtime = $(e.target).children().find('#chapter_runtime').val()
    min_runtime = parseInt($(e.target).children().find('#chapter_runtime').attr('min'))
    max_runtime = parseInt($(e.target).children().find('#chapter_runtime').attr('max'))
    chapter_quiz = if $("#chapter_quiz").get(0) then $("#chapter_quiz").get(0).checked else false

    if !!!runtime || (runtime >= min_runtime && runtime <= max_runtime)
      $.ajax(
        type: 'POST',
        url: "#{$(this).attr('action')}.json"
        enctype: 'multipart/form-data',
        data:
          'chapter[custom_image][base64]': image_path
          'chapter[alt_text_for_chapter_image]': $(e.target).children().find('#new_chapter_image_alt_text').val()
          'chapter[custom_image][filetype]': fileObject.filetype
          'chapter[custom_image][filename]': fileObject.filename
          'chapter[name]': $(e.target).children().find('#chapter_name').val()
          'chapter[description]': $(e.target).children().find('#chapter_description').val()
          'chapter[story_id]': $(e.target).children().find('#chapter_story_id').val()
          'chapter[status]': $(e.target).children().find('#chapter_status').val()
          'chapter[runtime]': $(e.target).children().find('#chapter_runtime').val()
          'chapter[country_tags]': $("#tags_country_tags").val()
          'chapter[office_tags]': $("#tags_office_tags").val()
          'chapter[role_tags]': $("#tags_role_tags").val()
          'chapter[quiz]': chapter_quiz
          'chapter[default_timeout_in_seconds]': $("#chapter_default_timeout_in_seconds").val()
          'authenticity_token': $('input[name=authenticity_token]').val()
          'chapter[asset_id_for_images]': asset_id
      ).done((data, textStatus, jqXHR) ->
        window.location.href = window.location.href.split("chapters")[0] + "chapters"
        return
      ).fail((jqXHR, textStatus, errorThrown) ->
        alert(jqXHR.responseText)
        $("input[type='submit']").val('Create')
        $("input[type='submit']").attr('disabled', false)
        return
      )
    else
      alert("Can’t set this runtime because it interferes with the Story Unlocking settings")
    true

  $('.move-chapter').click (event) ->
    chapter_id = $(this).attr("data-chapter-id")
    chapter_name = $(this).attr("data-chapter-name")
    action = "/chapters/" + chapter_id + "/move"
    form = $('#moveChapterModal').find('form')
    $(form).attr("action", action)
    $(form).find("#current-chapter-name").html(chapter_name)
